<template>
  <v-form v-model="formIsValid" @submit.prevent="submitPassword" class="d-flex justify-center flex-column w-100" ref="createPasswordForm">
    <v-card-text class="d-flex flex-column align-center pb-0" :class="!$vuetify.breakpoint.smAndUp && 'px-0 mx-0'">
      <PasswordField v-model="form.newPassword" hide-details :rules="[...$rules.passwordRules]" />
      <ul class="w-100 my-3">
        <li :class="['ml-5', minLengthMarker]">{{ $t('message.minPasswordLength') }}</li>
        <li :class="['ml-5', minNumericMarker]">{{ $t('message.minPasswordNumeric') }}</li>
      </ul>
      <v-text-field
        dense
        v-model="form.confirmPassword"
        :label="$t('label.confirmPassword')"
        type="password"
        class="stretch-append text-field-styling w-100"
        :rules="[$rules.confirmPassword(form.confirmPassword, form.newPassword)]"
        outlined
        rounded
      />
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4 pt-0">
      <app-button class="green-gradient-right override-disabled-styles mb-5" type="submit" :disabled="!formIsValid" :loading="loading" invert gradient :label="label" />
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { localeHelper } from '@/utils'
import validationHelper from '@/utils/validation.helper'
import PasswordField from '@/components/fields/PasswordField'
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  props: {
    reset: { type: Boolean, default: false },
    referrer: { type: Boolean, default: false }
  },

  components: { PasswordField, LeftArrow },

  data: () => ({
    loading: false,
    form: {
      newPassword: '',
      confirmPassword: ''
    },
    formIsValid: false
  }),

  computed: {
    label() {
      return this.reset ? localeHelper.getMessage('label.reset') : localeHelper.getMessage('label.create')
    },
    minLengthMarker() {
      return this.form.newPassword.length >= 6 ? 'validation-item-marked' : 'validation-item-unmarked'
    },
    minNumericMarker() {
      // must be strictly true, because if the validation fails, will return the error string which is still truthy
      return validationHelper.minOneNumeric(this.form.newPassword) === true ? 'validation-item-marked' : 'validation-item-unmarked'
    }
  },

  methods: {
    ...mapMutations('auth', ['storePasswordForm']),
    ...mapActions('common', ['resetPassword']),

    async submitPassword() {
      if (!this.formIsValid) return
      this.storePasswordForm(this.form)
      await this.resetPassword(this.form)
        .then(() => {
          this.$emit('next-step')
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-item-unmarked {
  list-style-type: circle;
}

.validation-item-marked::marker {
  color: var(--v-primary-darken1);
}
</style>
